import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initLeafDecorations() {
    const decorations = gsap.utils.toArray('[data-sh-leaf-decoration]');
    if (!decorations.length) return;

    decorations.forEach(function (el) {
        const path = el.querySelector('[data-sh-deco-plant]');
    
        if (!path) return;

        const length = path.getTotalLength();
        path.style.strokeDasharray = length;
        path.style.strokeDashoffset = length;
        path.style.fill = 'transparent';

        gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'top 60%',
                scrub: 1,
                once: false
            }
        })
        .fromTo(el,
            { scale: 0.6, transformOrigin: 'center center' },
            { scale: 1.3, duration: 2, ease: 'power2.inOut' }, 0
        )
        .fromTo(path,
            { strokeDashoffset: length, strokeOpacity: 0.75 },
            { strokeDashoffset: 0, duration: 2, ease: 'power2.inOut' }, 0
        )
        .to(el, { scale: 1, duration: 1.4, ease: 'expo.out' }, '-=0.2')
        .to(path, { fill: '#9FA165', duration: 1, ease: 'power2.inOut' }, '-=1')
        .to(path, { strokeOpacity: 0, duration: 0.8, ease: 'power1.in' }, '-=0.4');
    });
}
